<template>
  <base-section id="map" space="0">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15954.193505547932!2d103.79682843005816!3d1.4456556840705013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da13716ce6f8f5%3A0xdf1bab7896b93184!2sSingapore%20734785!5e0!3m2!1sen!2ssg!4v1644305685404!5m2!1sen!2ssg"
      allowfullscreen
      aria-hidden="true"
      frameborder="0"
      height="500"
      loading="lazy"
      style="border: 0; display: block"
      tabindex="0"
      width="100%"
    ></iframe>
  </base-section>
</template>

<script>
export default {
  name: "SectionMap",

  provide: {
    heading: { align: "center" },
  },
};
</script>
